export default __webpack_public_path__ + "static/media/480_dummy2016-restaurant03-de.9ac2680a.png";